import React, { useRef, useState, useEffect } from "react";
import vulductimg from "../assets/vulduct-image-1.png";
import mapsterimg from "../assets/mapster-image.png";
import ytscrps from "../assets/Screenshot 2026-02-12 004127.png"
import scrprimg from "../assets/scraper-ai.png"
import ecoming from "../assets/Screenshot 2026-02-12 025416.png"
import vikkmore from "../assets/vikkmore.png"
import montreal from "../assets/montreal-meet.png"
const projects = [
  {
    name: "Vulduct - Creator Digital Product Stores",
    description:
      "A free digital store platform designed for creators to launch and grow their brand.",
    link: "https://vulduct.web.app",
    image: vulductimg,
  },
  {
    name: "Mapster - Map Based reporting tool",
    description:
      "A map-based reporting tool that allows users to report issues in their locality with geotagged data and images.",
    link: "https://mapster-62700.web.app/",
    image: mapsterimg,
  },
  {
    name: "Scraper ai- AI for content Creation",
    description:
      "A scraper ai which helps you to manage your ai data and help you scale up helping you making content with AI.",
    link: "https://scraprai.vercel.app/",
    image: scrprimg,
  },
  {
    name: "GadgetCap - Personal Ecom Store",
    description:
      "Website to sell products",
    link: "https://gadgetcap.vercel.app/",
    image: ecoming,
  },
  {
    name: "Youtube Web scraper",
    description:
      "A youtube scraper which is good for channel research and give the best trending keywords and exclusive dtail of the youtube channel",
    link: "https://youtubewebscraper.vercel.app/",
    image: ytscrps,
  },
  {
    name: "Vikkmore - Ads free Music Listening",
    description:
      "A vikkmore is music app and website where you can enjoy add free music listening",
    link: "https://vikkmore.vercel.app/",
    image: vikkmore,
  },
  {
    name: "montreal meet",
    description:
      "montreal meet",
    link: "https://montroeal.vercel.app/",
    image: montreal,
  },
  
];

export default function Projects({ id }) {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    if (!("IntersectionObserver" in window)) {
      setIsVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // stop observing after animation
        }
      },
      {
        threshold: 0.2,
        rootMargin: "0px 0px -10% 0px",
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      id={id}
      className={`max-w-4xl mx-auto px-4 transition-opacity duration-1000 ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
    >
      <h2 className="text-3xl font-semibold mb-12 text-center">Projects</h2>
      <div className="grid md:grid-cols-2 gap-8">
        {projects.map(({ name, description, link, image }, index) => (
          <a
            href={link}
            key={name}
            target="_blank"
            rel="noopener noreferrer"
            className={`block rounded-xl border border-gray-200 bg-white shadow-md overflow-hidden transform transition-all duration-700 ${
              isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-5"
            }`}
            style={{ transitionDelay: `${index * 150}ms` }} // stagger animation
          >
            <img
              src={image}
              alt={`${name} screenshot`}
              className="w-full h-48 object-cover rounded-t-xl"
              loading="lazy"
            />
            <div className="p-6">
              <h3 className="text-2xl font-bold mb-3 text-blue-600">{name}</h3>
              <p className="text-gray-700 leading-relaxed">{description}</p>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
